<template>
  <div class="style-container">
    <div class="style-content fw-bold">
      <span />
      <span>
        {{ content }}
      </span>
    </div>
  </div>
</template>

<script>
export default {
  name: "ExpandableListHeader",
  props: {
    content: {
      type: String,
    }
  },
};
</script>

<style lang="scss" scoped>
.style-container {
  height: 20px;
  line-height: 20px;
  background: #dadada;
}
.style-content {
  display: flex;
  justify-content: space-between;
  font-size: 12px;
  margin: 0 10px;
  color: #4a4a4a
}
</style>
